import { createApp } from 'vue'
import BulkSigningPortal from './BulkSigningPortal.vue'

const safeRegisterElement = (name, element, options = {}) => !window.customElements.get(name) && window.customElements.define(name, element, options)

safeRegisterElement('bulk-signing-portal', class extends HTMLElement {
  connectedCallback () {
    this.appElem = document.createElement('div')
    this.appElem.classList.add('w-full', 'h-full')

    this.app = createApp(BulkSigningPortal, {
      programmeName: this.dataset.programmeName || '',
      isTrainer: this.dataset.isTrainer === 'true',
      isSponsor: this.dataset.isSponsor === 'true',
      alreadySigned: this.dataset.alreadySigned === 'true',
      completed: this.dataset.completed === 'true',
      submitUrl: this.dataset.submitUrl,
      returnUrl: this.dataset.returnUrl || '',
      // Submission form dataset passed through
      submissionDataset: (() => {
        try {
          return this.dataset.submissionDataset ? JSON.parse(this.dataset.submissionDataset) : null
        } catch (e) {
          console.error('Failed to parse submissionDataset', e)
          return null
        }
      })()
    })

    this.app.mount(this.appElem)
    this.appendChild(this.appElem)
  }

  disconnectedCallback () {
    this.app?.unmount()
    this.appElem?.remove()
  }
})
